export const toTableRowItems = items =>
  items.map(item => ({
    id: item.id,
    firstName: item.firstName,
    lastName: item.lastName,
    email: item.email,
    createdDate: item.createdDate,
    phone: item.phone,
    delegatesCount: item.delegates.length,
    activeAssignmentsCount: item.activeAssignmentsCount || 'No active assignments',
    isEnabled: item.isEnabled ? 'Enabled' : 'Disabled'
  }))
